import React, {Fragment, useContext, useEffect, useState} from "react";
import CardContainer from "../../../components/CardContainer";
import Card from "../../../components/Card";
import {Link} from "react-router-dom";
import {LoaderContext} from "../../../context/LoaderContext";
import axios from "axios";
import ModalConfirm from "../../../components/ModalConfirm";
import NsDataTable from "../../../components/tabelle/NsDataTable";

function ListTipiSoci() {

    const [loadingData, setLoadingData] = useState(true);
    const [data, setData] = useState([]);
    const [tipoSocioSel, setTipoSocioSel] = useState(null);
    const [show, setShow] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    function getTipiSoci() {
        startChiamata()
        axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/utente/tipi-socio/").then((response) => {
            setData(response.data.data);
            setLoadingData(false);
            endChiamata()
        });
    }

    useEffect(() => {
        if (loadingData === true) {
            getTipiSoci()
        }
    }, []);

    const openModalDel = (utente) => {
        setTipoSocioSel(utente)
        setShow(true);
    }

    return (
        <CardContainer>
            <Card
                icon={'fas fa-user-tag'}
                title={'Tipi di Socio'}
                getBottoniDx={() =>
                    <Fragment>
                        <Link to="/upd-tipo-socio" className={"btn btn-card"}>
                            <i className="fas fa-plus-circle"/> Aggiungi
                        </Link>
                    </Fragment>
                }
            >
                <ModalConfirm
                    show={show}
                    handleClose={() => setShow(false)}
                    handleOk={() => {
                        setShow(false);
                        startChiamata()
                        axios.delete(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/utente/tipi-socio/" + tipoSocioSel.id_tipo_soci).then((response) => {
                            setData(response.data.data);
                            endChiamata()
                        });
                    }}
                    testo={"Sicuro di voler eliminare il tipo di socio: " + (tipoSocioSel && (tipoSocioSel.id_tipo_soci)) + "?"}/>
                {
                    loadingData ? (
                        <p>Caricamento in corso...</p>
                    ) : (
                        <NsDataTable
                            data={data}
                            columns={[
                                {
                                    name: 'Codice Tipo Socio',
                                    selector: row => row.id_tipo_soci,
                                    sortable: true,
                                },
                                {
                                    name: 'Descrizione Tipo Socio',
                                    selector: row => row.descrizione,
                                    sortable: true,
                                },
                                {
                                    name: 'Quota €',
                                    selector: row => row.quota,
                                    sortable: true,
                                },
                                {
                                    name: 'Ordinamento',
                                    selector: row => row.sort,
                                    sortable: true,
                                },
                                {
                                    name: 'RFI / Abarth',
                                    selector: row => row.abarth == '1' ?
                                        <span className={"rfi-etichetta rfi-etichetta--arancione"}>Abarth</span>
                                        : <span className={"rfi-etichetta rfi-etichetta--blu"}>RFI</span>,
                                    sortable: true,
                                },
                                {
                                    name: '',
                                    selector: row => <Fragment>
                                        <div className="btn-group" role="group"
                                             aria-label="Button group with nested dropdown">
                                            <div className="btn-group" role="group">
                                                <button id="btnGroupDrop1" type="button"
                                                        className="btn btn-dark dropdown-toggle"
                                                        data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i className="fa-solid fa-bars"></i>
                                                </button>
                                                <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                    <li>
                                                        <Link to={"/upd-tipo-socio/" + row.id_tipo_soci}
                                                              className="dropdown-item"
                                                              data-toggle="tooltip" title="Modifica">
                                                            <i className="fas fa-pen"/> Modifica
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item"
                                                                data-toggle="tooltip" title="Elimina" onClick={() => {
                                                            openModalDel(row)
                                                        }}>
                                                            <i className="fas fa-trash"/> Elimina
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Fragment>,
                                    sortable: false,
                                    right: true,
                                }
                            ]}
                            addPagination={true}
                            funzioneFiltro={(item, filtro) => {
                                return (item.id_tipo_soci && item.id_tipo_soci.toLowerCase().includes(filtro.toLowerCase()))
                                    || (item.descrizione && item.descrizione.toLowerCase().includes(filtro.toLowerCase()))
                                    || (item.quota && item.quota.toLowerCase().includes(filtro.toLowerCase()))
                                    || (item.abarth == '1' && 'abarth'.includes(filtro.toLowerCase()))
                                    || (item.abarth != '1' && 'rfi'.includes(filtro.toLowerCase()))
                            }}
                        >
                        </NsDataTable>
                    )}
            </Card>
        </CardContainer>
    );
}

export default ListTipiSoci;
